import apiClient from '@shared/apiClient'

const SERVICE_PATH = 'user-content/saved-search'

export const getApiClient = () => apiClient.partneringOnePlus(SERVICE_PATH)
